export enum ExtranetModule {
    Shipment,
    Agencies,
    Settlements,
    Logistics,
    All,
    SampleApplication,
    Users,
    ArchiveNotifications
}
